
export default {
  name: 'EventCardLinkButton',
  props: {
    link: {
      type: String,
      required: true
    },

    isTooltip: {
      type: Boolean,
      required: true
    }
  }
}
